import React from 'react';

/**
 * The Split SDK factory once it has been idle-loaded, null until then.
 * Consumers treat it as a ready flag and wrap live flag reads in `SplitScope`.
 */
export const SplitReadyContext = React.createContext<SplitIO.IBrowserSDK | null>(null);
